import { usePageContext } from '../contexts/page-context';

import type { CardConfigs } from '@web-platform/shared-travel-tools-types/src/page-context';

export const useCardConfigs = (): CardConfigs => usePageContext().cardConfigs;
